module.exports = __webpack_public_path__ + "static/media/GreatRoom2.44b61cc8.jpg";